import React, { useEffect, useState } from 'react';
import styles from './PaymentFailure.module.css';
import { useNavigate } from 'react-router-dom';
const PaymentFailure = () => {
  const [errorInfo, setErrorInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const errorData = query.get('error');

    if (errorData) {
      try {
        const decoded = atob(errorData);
        const parsed = JSON.parse(decoded);
        setErrorInfo(parsed);
      } catch (err) {
        console.error("Failed to decode error data:", err);
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  }, []);

  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.spinner}></div>
        <p>Processing payment status...</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.errorIcon}>
            <svg viewBox="0 0 24 24">
              <path fill="currentColor" d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z" />
            </svg>
          </div>
          <h1>Payment Failed</h1>
          <p className={styles.subheader}>We couldn't process your payment</p>
        </div>

        {errorInfo && (
          <div className={styles.details}>
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Error Code:</span>
              <span className={styles.detailValue}>{errorInfo.code || 'N/A'}</span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Message:</span>
              <span className={styles.detailValue}>{errorInfo.message || 'Unknown error occurred'}</span>
            </div>
            {errorInfo.suggestion && (
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>Suggestion:</span>
                <span className={styles.detailValue}>{errorInfo.suggestion}</span>
              </div>
            )}
          </div>
        )}

        <div className={styles.troubleshoot}>
          <h3>What to do next?</h3>
          <ul>
            <li>Check your payment details and try again</li>
            <li>Ensure you have sufficient funds</li>
            <li>Contact your bank if you suspect any issues</li>
            <li>Try a different payment method</li>
          </ul>
        </div>

        <div className={styles.actions}>
          <button className={styles.retryButton} onClick={() => navigate('/')}>Back to home</button>
          <button className={styles.secondaryButton}>Contact Support</button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;